var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22734 5.33398V16.4785H12.2504V5.33398H2.22734ZM2.22734 5.33398H0H14.4777M5.56834 5.33398V16.4785M8.90935 5.33398V16.4785M3.89784 5.33398L4.26667 3.6936C4.38993 3.14536 4.65203 2.63799 5.02779 2.22018L5.09247 2.14826C5.40504 1.80072 5.79733 1.53427 6.23562 1.37183V1.37183C6.88292 1.13192 7.59477 1.13192 8.24207 1.37183V1.37183C8.68036 1.53427 9.07265 1.80072 9.38522 2.14826L9.4499 2.22018C9.82567 2.63799 10.0878 3.14536 10.211 3.6936L10.5799 5.33398",
    stroke: "#456D64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelIcon);
export default __webpack_public_path__ + "static/media/del_icon.4852546658c0116795796bb578e7e82d.svg";
export { ForwardRef as ReactComponent };